var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: "Zugangsdaten (Link) senden",
        size: "lg",
        "ok-text": "Senden",
        "ok-disabled": !_vm.linkValid || _vm.sending,
        "ok-loading": _vm.sending,
        closable: !_vm.sending
      },
      on: {
        ok: _vm.send,
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c("div", [
        _vm._v(
          "\n\t\tSende dem Kandidaten rechtzeitig die Zugangsdaten die er für einen Video-Call und/oder eine Onlinetätigkeit\n\t\tbenötigt.\n\t"
        )
      ]),
      _vm._v(" "),
      _c(
        "FormGroup",
        {
          staticClass: "mt-4",
          attrs: {
            label: "Zugangsdaten (Link)",
            state: _vm.linkValid,
            "invalid-feedback": _vm.linkError,
            "feedback-beneath": ""
          }
        },
        [
          _c("b-input", {
            model: {
              value: _vm.link,
              callback: function($$v) {
                _vm.link = $$v
              },
              expression: "link"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "FormGroup",
                { attrs: { label: "Benutzername (optional)" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.username,
                      callback: function($$v) {
                        _vm.username = $$v
                      },
                      expression: "username"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "FormGroup",
                { attrs: { label: "Passwort (optional)" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }